import { DateTime as DT } from 'luxon';
import InputPriceRate from 'components/others/InputPriceRate';
import { UserNameItem } from 'modules/user';
import WorkerSharePie from './WorkerSharePie';
import type { WorkerFormRow } from '../model';

interface WorkersTableRowProps {
    row: WorkerFormRow;
    index: number;
    readOnly: boolean;
    rate: number;
    incomeAmount: number;
    onAmountChange: (index: number, amount: number, amountRate: number) => void;
}

const getSharePercent = (amount: number, incomeAmount: number): number => {
    if (!(incomeAmount > 0)) return 0;
    return Math.round(((Number(amount) || 0) / incomeAmount) * 1000) / 10;
};

const WorkersTableRow = ({
    row,
    index,
    readOnly,
    rate,
    incomeAmount,
    onAmountChange,
}: WorkersTableRowProps) => {
    const hasChange = Number(row.dt) > 0;
    const changedAt = hasChange ? DT.fromMillis(row.dt).toFormat('dd.MM.yyyy HH:mm') : '';
    const sharePercent = getSharePercent(row.amount, incomeAmount);

    return (
        <tr>
            <td className="username">
                <UserNameItem
                    smallMode
                    user={{
                        userName: row.userName,
                        userEmail: row.userEmail,
                        userPicture: row.userPicture || undefined,
                    }}
                />
            </td>
            <td className="amount">
                <InputPriceRate
                    style={{ maxWidth: '250px' }}
                    value={Number(row.amount) || 0}
                    allowNegative={false}
                    disabled={readOnly}
                    onValueChange={(val: { floatValue?: number; value?: string }) => {
                        const amount = Number(val?.floatValue ?? val?.value) || 0;
                        onAmountChange(index, amount, Math.round(amount * rate * 100) / 100);
                    }}
                />
            </td>
            <td className="share">
                <WorkerSharePie percent={sharePercent} />
            </td>
            <td className="date">
                {hasChange ? (
                    <>
                        <span className="d-block text-nowrap">{changedAt}</span>
                        {row.ownerName ? (
                            <span className="d-block text-muted text-truncate fs-12">
                                {row.ownerName}
                            </span>
                        ) : null}
                    </>
                ) : (
                    <span className="text-muted">—</span>
                )}
            </td>
        </tr>
    );
};

export default WorkersTableRow;
